// extracted by mini-css-extract-plugin
module.exports = {"container":"MicroCheckInDetails_container__31kLW","loading":"MicroCheckInDetails_loading__NfOmi"};